import { useDispatch, useSelector } from 'react-redux';
import { Stack, Typography } from '@mui/material';
import { useEffect } from 'react';

import { TableCellCustom } from '@app/components/table';
import { IInternDetailsSchema } from '../types';
import { StatusTag, formatTimeSlots } from '@app/components';
import { CustomAvatar } from '@app/components/custom-avatar';
import { selectEmployeesState, getEmployees } from '@app/modules/employees';
interface Props {
  row: IInternDetailsSchema;
}

const InternDetailsRow = (props: Props) => {
  const { row } = props;

  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
  const actionBy = `${row.action.firstName} ${row.action.lastName}`;

  const actionTimeArray = Array.isArray(row?.actionTime)
    ? row?.actionTime
    : [row?.actionTime].filter(Boolean);
  const actionTime = formatTimeSlots(actionTimeArray);

  const managerState = useSelector(selectEmployeesState);
  const manager = managerState.data?.records;
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getEmployees());
  }, [dispatch]);
  return (
    <>
      <TableCellCustom flex align="center">
        <Typography variant="body2">{row?.id}</Typography>
      </TableCellCustom>
      <TableCellCustom width={50} align="center">
        <StatusTag status={row?.status ?? 'NA'} />
      </TableCellCustom>
      <TableCellCustom flex align="center" style={{ width: '50%' }}>
        <Typography variant="body2" align="center" style={{ width: '100%' }}>
          {row?.reason ?? 'NA'}
        </Typography>
      </TableCellCustom>
      <TableCellCustom flex align="center" style={{ width: '20%' }}>
        <Typography variant="body2">{actionTime ?? 'NA'}</Typography>
      </TableCellCustom>
      <TableCellCustom width={'200px'} align="center">
        <Stack style={{ flexDirection: 'row', alignItems: 'center', gap: '9px' }}>
          <CustomAvatar name={actionBy} color="info" />
          <Typography variant="body2">{actionBy ?? 'NA'}</Typography>
        </Stack>
      </TableCellCustom>
      <TableCellCustom width={180} align="center">
        {manager?.find((option) => row.interviewer === option.id)
          ? manager.map(
              (option, index) =>
                row.interviewer === option.id && (
                  <Stack
                    key={index}
                    style={{ flexDirection: 'row', alignItems: 'center', gap: '9px' }}
                  >
                    <CustomAvatar name={`${option.firstName}${option.lastName}`} color="info" />
                    <Typography variant="body2" width={'60px'}>
                      {option.firstName}
                    </Typography>
                  </Stack>
                )
            )
          : 'NA'}
      </TableCellCustom>
    </>
  );
};

export { InternDetailsRow };
